import useHierarquiaMapaCalor from './useHierarquiaMapaCalor';

export default function useDashboardMapaCalorNps(entidadeId, options) {
  return useHierarquiaMapaCalor(entidadeId, {
    ...options,
    endpoint: '/FormularioGlobalDashboard/ObterMapaCalorNps',
  });
}
